/* eslint-disable*/
import React from 'react';
import useStyles from './MainLogo.styles';
import { ReactComponent as Logo } from '../../assets/images/VectorIconWhite.svg';

const MainLogo = ({ handleDrawerToggle }) => {
  const classes = useStyles();
  return (
    <div className={classes.logobox} onClick={handleDrawerToggle}>
      <Logo className={classes.logo} />
      {/* <img
        className={classes.logo}
        src={require('../../assets/images/vectorgloballogo.png').default}
        alt="Logo"
      /> */}
    </div>
  );
};

export default MainLogo;
